import { Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NotificationService } from '@services/notification.service';
import { saveAs } from "file-saver";
import { Subject, Subscription, of } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { ItemsUploadService } from '../../../services/items-upload.service';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import { videoAssetGroups } from '@configs/videoTitles';

export interface ReportData {
  indexNo: number;
  rowNo: number;
  errorComment: string;
}
@Component({
  selector: 'app-add-multiple-item',
  templateUrl: './add-multiple-item.component.html',
  styleUrls: ['./add-multiple-item.component.scss']
})
export default class AddMultipleItemComponent implements OnInit, OnDestroy {

  dataSource: MatTableDataSource<ReportData>;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator) set content(sort: MatPaginator) {
  }

  displayedColumns: string[] = ['indexNo', 'rowNo', 'errorComment'];
  examineeData$: Subscription | undefined;
  isNoError = false

  @ViewChild("fileUpload", { static: false }) fileUpload: ElementRef; files = [];
  uploadFileForm: FormGroup;
  uploadSuccess = false;
  uploadResponse: any = 'no status';
  eventData: any;
  uploadEmpty: boolean = false;
  emptyMsg: any;
  errorHeading: any;
  errorMsg: [];
  isValidFileName: boolean = false;
  private unsubscribe: Subject<void> = new Subject<void>();
  isHidden = false;
  videoLinks: any;
  videoAssetGroups = videoAssetGroups;
  hoverVideoApiCall: boolean = false;
  isError: boolean = false;
  constructor(private location: Location, private itemUpload: ItemsUploadService,
    private notificationService: NotificationService, private webErrorService: WebErrorService,
    private fb: FormBuilder, public translate: TranslateService) { }

  ngOnInit(): void {
    this.uploadFileForm = this.fb.group({
      file: ['']

    })
  }

  ngAfterViewInit(): void {
    document.onclick = (args: any) : void => {
      if(args.target.className != 'trainingIcon') {
        this.isHidden = false;
      }
    }
  }

  onTrainingIcon(groupName) {
    this.isHidden = true;
    if (!this.hoverVideoApiCall) {
      this.itemUpload.videoTutorial(groupName).subscribe(video => {
        this.videoLinks = video.data;
        this.hoverVideoApiCall = true;
      });
    }
  }

  open_in_new_window(features, link) {
    var new_window;
    if(features !== undefined && features !== '') {
      new_window = window.open('', '_blank', features);
    }
    else {
      new_window = window.open('', '_blank');
    }

    let video = '<video controls controlsList="nodownload" style="width: 100%; height: 100vh;"><source src="' + link + '" type="video/mp4" /></video>'

    if(link !== null && link !== '') {
      new_window.document.write('<!doctype html><html><head><title>Video Player</title><meta charset="UTF-8" /></head><body style="padding: 0; margin: 0;" oncontextmenu="return false">' + video + '</body></html>');
    }
  }

  // Back to item-management page
  goToPrevious() {
    this.location.back();
  }

  download(): void {
    let fileName = 'ItemsTemplate';
    let checkFileType = '.xml';
    var fileType = ""
    if (checkFileType == ".xml") {
      fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    }
    this.itemUpload.DownloadFile(fileName, fileType)
      .subscribe(
        success => {
          saveAs(success, fileName);
        },
        err => {
          alert("Server error while downloading file.");
        }
      );
  }
  uploadExcelFile(): void {
    this.isValidFileName = false
    this.files = [];
    const fileUpload = this.fileUpload.nativeElement;
    fileUpload.onchange = () => {
      const fileNameMaxLength = 200;
      for (let index = 0; index < fileUpload.files.length; index++) {
        const file = fileUpload.files[index];
        this.files.push(file);
        if (file.name.length > fileNameMaxLength) {
          this.isValidFileName = true
        }
      }
      if (!this.isValidFileName) {
        this.uploadFiles();
      }
    };
  }

  private uploadFiles(): void {
    this.fileUpload.nativeElement.value = '';
    this.files.forEach(file => {
      if (!file.uploaded) {
        this.uploadFile(file);
      }
    });
  }

  uploadFile(file): void {

    const formData = new FormData();
    formData.append('files', file);
    this.examineeData$ = this.itemUpload.upload(formData).subscribe(
      event => {
        file.uploaded = true;
        this.eventData = event;
        this.isError = false;
        if (this.eventData?.failedData?.length == 0 || this.eventData?.failedData?.length == null) {
          this.isNoError = true;
          this.uploadSuccess = true;
          this.uploadEmpty = true;
          this.uploadResponse = event;
          this.dataSource = new MatTableDataSource(this.uploadResponse?.failedData);
          this.dataSource.paginator = this.paginator;
        }
        else {
          this.emptyMsg = '';
          this.uploadSuccess = false;
          this.isNoError = false;
          this.uploadResponse = event;
          this.dataSource = new MatTableDataSource(this.uploadResponse?.failedData);
          // ------Set translation for pagination------
          setTimeout(() => {
            this.dataSource.paginator = this.paginator;
            if (this.dataSource.paginator) {
              this.translate.stream([
                'items.multipleItems.pagination.pageLabel',
                'items.multipleItems.pagination.firstPage',
                'items.multipleItems.pagination.lastPage',
                'items.multipleItems.pagination.nextPage',
                'items.multipleItems.pagination.prevPage'
              ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
                this.dataSource.paginator._intl.itemsPerPageLabel = translation['items.multipleItems.pagination.pageLabel'];
                this.dataSource.paginator._intl.firstPageLabel = translation['items.multipleItems.pagination.firstPage'];
                this.dataSource.paginator._intl.lastPageLabel = translation['items.multipleItems.pagination.lastPage'];
                this.dataSource.paginator._intl.nextPageLabel = translation['items.multipleItems.pagination.nextPage'];
                this.dataSource.paginator._intl.previousPageLabel = translation['items.multipleItems.pagination.prevPage'];

                this.dataSource.paginator._intl.changes.next();
              });
            }
          });

          if (this.uploadResponse?.totalNoOfRecords == 0) {
            this.emptyMsg = this.translate.instant('examinee.multipleExaminee.Error') + this.uploadResponse?.failedData[0]?.message;
            this.errorHeading = this.translate.instant('examinee.multipleExaminee.errMsg2');
          }
        }
      }, (error: any) => {
        this.isError = true;
        this.uploadSuccess = true;
        this.emptyMsg = '';
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
      });
    //),
    catchError((error: HttpErrorResponse) => {
      return of(`${file.data.name} upload failed.`);
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
